import axios from '@/axios/api.request'

export const save = (from) => axios.request({
    url: '/order/info/save',
    data: from,
    method: 'post'
  })

export const edit = (from) => axios.request({
  url: '/order/info/edit',
  data: from,
  method: 'post'
  })